export const weOffers = `
    <div class="w-full lg:w-[80%] mx-auto"
     data-aos="fade-up"
      data-aos-duration="300"
    >
      <!-- Heading Section -->
      <div class="py-12">
        <h2 class="lg:text-4xl font-medium text-[#000072] text-xl text-center">
          What we Offer
        </h2>
        <p
          class="text-sm font-normal text-gary-600 text-center my-2  px-2"
        >
          We are a full-stack institutional debt raising platform that offers
          solutions to all stakeholders
        </p>
      </div>

      <!-- Cards Section -->
      <div
        class="flex flex-col lg:flex-row gap-2 justify-center items-stretch mt-6"
        data-aos="fade-up"
      data-aos-duration="300"
      >
        <!-- Card 1 -->
        <div
          class="w-full lg:w-1/3 bg-white rounded-xl shadow-lg flex flex-col border border-gray-200 py-5"
        >
          <p class="font-semibold text-2xl text-blue-700 py-3 text-center">
            Borrower
          </p>
          <p class="font-semibold text-xs text-gray-700 py-1 text-center">
            Match you with right set of lenders
          </p>
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/BorrowerCard1.svg"
            alt="Borrower"
            class="w-full h-48 object-contain px-6"
          />
          <div class="px-6 py-4 flex-1 flex flex-col justify-between">
            <div>
              <p class="text-gray-700 text-sm mb-2">
                ibankey offers a seamless onboarding experience, using smart
                technology to match you with the right lenders or investors,
                cutting deal time significantly. Our expert mentors and case
                managers support you at every step, ensuring smooth execution.
                We help you secure the best deals, making fundraising faster,
                easier, and more efficient.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 2 -->
        <div
          class="w-full lg:w-1/3 bg-white rounded-xl shadow-lg flex flex-col border border-gray-200 box-border py-5"
        >
          <p class="font-semibold text-2xl text-blue-700 py-3 text-center">
            Lender
          </p>
          <p class="font-semibold text-xs text-gray-700 py-1 text-center">
            Finds right set of borrower for you
          </p>
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/lenderCard2.svg"
            alt="Lender"
            class="w-full h-48 object-contain px-6"
          />
          <div class="px-6 py-4 flex-1 flex flex-col justify-between">
            <div>
              <p class="text-gray-700 text-sm">
                Our tech-enabled platform curates intelligent deals tailored to
                your needs. We provide all essential information at once,
                empowering borrowers and enabling faster decisions by risk
                underwriters. More than just displaying deals, we deliver
                critical insights and revolutionary technology that streamlines
                the entire process for faster, smarter financial transactions.
              </p>
            </div>
          </div>
        </div>

        <!-- Card 3 -->
        <div
          class="w-full lg:w-1/3 bg-white rounded-xl shadow-lg flex flex-col border border-gray-200 box-border py-5"
        >
          <p class="font-semibold text-2xl text-blue-700 py-3 text-center">
            Partner
          </p>
          <p class="font-semibold text-xs text-gray-700 py-1 text-center px-0 lg:px-10">
            We are your partner in the journey of growing your reach & business.
          </p>
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/newAssets/partnerCard1.svg"
            alt="Partner"
            class="w-full h-48 object-contain px-6"
          />
          <div class="px-6 py-4 flex-1 flex flex-col justify-between">
            <div>
              <p class="text-gray-700 text-sm">
                Our platform empowers you to scale your capabilities and expand
                your reach by connecting with a wide network of lenders and
                investors. It boosts efficiency, helping you deliver on mandates
                faster. With a smart deal management dashboard, you can track
                progress and manage transactions seamlessly in real-time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    `;
